import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useContactsQuery } from 'core/api/contacts';
import { buildRecommendationChain } from 'core/useCases/contacts/utils';
import ChevronDown from 'images/icons/ChevronDown.svg?react';
import ContactSubCard from '../ContactSubCard';
import { SChain, SChainNode, SConnector, SYouNode } from './styles';

type ContactMappingProps = {
    contactId: string;
};

const ContactMapping: FC<ContactMappingProps> = ({ contactId }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { data: contactsData } = useContactsQuery();
    const contacts = useMemo(() => contactsData ?? [], [contactsData]);
    const chain = useMemo(() => buildRecommendationChain(contactId, contacts), [contactId, contacts]);

    // Toute la carte est cliquable : on navigue vers la fiche du maillon.
    const goToContact = (id: string) => {
        history.push(`/contact/${id}`);
    };

    if (chain.length === 0) {
        return null;
    }

    return (
        <SChain>
            {chain.map((contact) => (
                <div key={contact.id}>
                    <SChainNode
                        onClick={() => goToContact(contact.id)}
                        onKeyDown={() => goToContact(contact.id)}
                        role="button"
                        tabIndex={0}
                    >
                        <ContactSubCard contact={contact} isRankAndParentDisplayed />
                    </SChainNode>
                    <SConnector>
                        <ChevronDown />
                    </SConnector>
                </div>
            ))}
            <SYouNode>{t('common.you')}</SYouNode>
        </SChain>
    );
};

export default ContactMapping;
